import { render, staticRenderFns } from "./ProductSliderBlock.vue?vue&type=template&id=241f0504&"
import script from "./ProductSliderBlock.vue?vue&type=script&lang=js&"
export * from "./ProductSliderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports